import { render } from "./PasteTool.vue?vue&type=template&id=0689bc33&scoped=true"
import script from "./PasteTool.vue?vue&type=script&lang=js"
export * from "./PasteTool.vue?vue&type=script&lang=js"

import "./PasteTool.vue?vue&type=style&index=0&id=0689bc33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0689bc33"]])

export default __exports__